<template>
  <b-modal
    id="modalInsertIndication"
    centered
    title="Insert indication"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
   <div class="mb-3">
      <label for="indicated_by" class="form-label">Indicado por (ID)</label>
      <b-form-input
        id="indicated_by"
        v-model="indicated_by"
        placeholder="Digite o ID de quem indicou"
        type="number"
        :state="!errorsForm.indicated_by"
      />
      <b-form-invalid-feedback v-if="errorsForm.indicated_by">
        {{ errorsForm.indicated_by }}
      </b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="user_id" class="form-label">ID do Indicado</label>
      <b-form-input
        id="user_id"
        v-model="user_id"
        placeholder="Digite o ID do Indicado indicado"
        type="number"
        :state="!errorsForm.user_id"
      />
      <b-form-invalid-feedback v-if="errorsForm.user_id">
        {{ errorsForm.user_id }}
      </b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="hash" class="form-label">Hash</label>
      <b-form-input
        id="hash"
        v-model="hash"
        placeholder="Digite o hash"
        type="text"
        :state="!errorsForm.hash"
      />
      <b-form-invalid-feedback v-if="errorsForm.hash">
        {{ errorsForm.hash }}
      </b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="email" class="form-label">E-mail</label>
      <b-form-input
        id="email"
        v-model="email"
        placeholder="Digite o e-mail"
        type="email"
        :state="!errorsForm.email"
      />
      <b-form-invalid-feedback v-if="errorsForm.email">
        {{ errorsForm.email }}
      </b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="phone" class="form-label">Telefone (opcional)</label>
      <b-form-input
        id="phone"
        v-model="phone"
        placeholder="Digite o telefone"
        type="tel"
        :state="phoneValid"
      />
      <b-form-invalid-feedback v-if="errorsForm.phone">
        {{ errorsForm.phone }}
      </b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="name" class="form-label">Nome</label>
      <b-form-input
        id="name"
        v-model="name"
        placeholder="Digite o nome"
        type="text"
        :state="!errorsForm.name"
      />
      <b-form-invalid-feedback v-if="errorsForm.name">
        {{ errorsForm.name }}
      </b-form-invalid-feedback>
    </div>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="success" @click="submitData">Concluir</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InsertIndication from '@services/resources/OperationsService';

const insertIndication = InsertIndication.build();

export default {
  name: 'modalInsertIndication',
  data() {
    return {
      user_id: '',
      indicated_by: '',
      hash: '',
      email: '',
      phone: null,
      name: '',
      errorsForm: {},
    };
  },
  computed: {
    phoneValid() {
      if (!this.phone) return null; // neutro se vazio
      return this.phone.length >= 8;
    },
  },
  methods: {
    validateFields() {
      this.errorsForm = {};

      if (!this.user_id.toString().trim()) {
        this.errorsForm.user_id = 'ID do Indicado é obrigatório.';
      }

      if (!this.indicated_by.toString().trim()) {
        this.errorsForm.indicated_by = 'ID do Indicador é obrigatório.';
      }

      if (!this.hash.trim()) {
        this.errorsForm.hash = 'O campo Hash é obrigatório.';
      }

      if (!this.email.trim()) {
        this.errorsForm.email = 'O campo E-mail é obrigatório.';
      }

      if (this.phone && this.phone.length < 8) {
        this.errorsForm.phone = 'Telefone deve ter pelo menos 8 dígitos.';
      }

      if (!this.name.trim()) {
        this.errorsForm.name = 'O campo Nome é obrigatório.';
      }

      return Object.keys(this.errorsForm).length === 0;
    },

    async submitData() {
      if (!this.validateFields()) return;

      try {
        const payload = {
          user_id: this.user_id,
          indicated_by: this.indicated_by,
          hash: this.hash,
          email: this.email,
          phone: this.phone || null,
          name: this.name,
        };

        await insertIndication.post('insert-indication', payload);

        this.$bvToast.toast('Indicação inserida com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });

        this.$bvModal.hide('modalInsertIndication');
        this.resetForm();
      } catch (error) {
        let message = 'Erro ao inserir indicação';

        if (
          error.response &&
          error.response.status === 422 &&
          typeof error.response.data === 'string'
        ) {
          const parsed = JSON.parse(error.response.data);

          if (parsed.errors) {
            message = Object.values(parsed.errors)
              .flat()
              .join('\n');
          }

        } else if (
          error.response &&
          typeof error.response.data === 'object' &&
          error.response.data.message
        ) {
          message = error.response.data.message;

        } else if (error.message) {
          message = error.message;
        }

        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      }
    },

    resetForm() {
      this.user_id = '';
      this.indicated_by = '';
      this.hash = '';
      this.email = '';
      this.phone = null;
      this.name = '';
      this.errorsForm = {};
    },
  },
};
</script>
